import * as types from './types';

function setSchedule(scheduleId, data) {
    return {
        meta: {
            id: scheduleId,
        },
        payload: data,
        type: types.SET_SCHEDULE,
    };
}

export {
    setSchedule,
};

export default {
    setSchedule,
};
